import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import contactNoteDialogService from 'services/contactNoteDialogService';
import { TopicDropdownOption } from 'utils/contactNoteUtil';

export const useGetOrganisationalUnitDropdownValues = () => {
  return useQuery<TopicDropdownOption[], AxiosError>({
    queryKey: ['organisationalUnitValues'],
    queryFn: () => contactNoteDialogService.getOrganisationalUnitValues(),
  });
};
